import React, { useState } from 'react';
import SimpleInput from '../SimpleInput';
import PrimaryBtn from './primaryBtn';
import DatePickerComponent from 'src/Components/DatePickerComponent';
import { toast } from 'react-toastify';
import moment from 'moment';

interface IDateFilterProps {
  apply?: (startDate: string, endDate: string) => void;
  reset?: () => void;
  dateFormat?: string;
}

const StartAndEndDateFilter: React.FC<IDateFilterProps> = ({
  apply = () => {},
  reset = () => {},
  dateFormat = "YYYY-MM-DD",
}) => {
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');

  // Handle start date change with validation
  const handleStartDateChange = (val: string) => {
    if (endDate && val && new Date(val) > new Date(endDate)) {
      toast('Start date cannot be later than end date.', { type: 'error' });
      return;
    }
    setStartDate(val);
  };

  // Handle end date change with validation
  const handleEndDateChange = (val: string) => {
    if (startDate && val && new Date(val) < new Date(startDate)) {
      toast('End date cannot be earlier than start date.', { type: 'error' });
      return;
    }
    setEndDate(val);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
      <div className="label-color-change-test-product">
        <DatePickerComponent
          id="Sale Start Date"
          value={startDate}
          onChange={handleStartDateChange}
          adminDate={true}
          iconGreenNone={true}
        />
      </div>
      <div className="label-color-change-test-product">
        <DatePickerComponent
          id="Sale End Date"
          value={endDate}
          onChange={handleEndDateChange}
          adminDate={true}
          iconGreenNone={true}
        />
      </div>
      {/* Empty column for large screens */}
      <div className="hidden md:block"></div>
      <div className="flex items-center gap-3 justify-end">
        <PrimaryBtn
          // disabled={!startDate && !endDate}
          ButtonText="Reset"
          onPress={() => {
            setStartDate('');
            setEndDate('');
            reset();
          }}
          btnExtraStyle={{
            borderRadius: '1.5rem',
            backgroundColor: '#004540',
            padding: '6px 30px',
          }}
        />
        <PrimaryBtn
          ButtonText="Apply"
          onPress={() => {
            let stDate : Date | string = "";
            let edDate : Date | string = "";
            if (startDate) {
              stDate = new Date(startDate);
              if(!dateFormat){
              stDate.setHours(4, 59, 59, 999);
              }
              stDate = stDate.toISOString();
              if (dateFormat){
                stDate = moment(stDate).format(dateFormat);
              }
            }
            if (endDate) {
              edDate = new Date(endDate);
              if(!dateFormat){
                edDate.setDate(edDate.getDate() + 1);
                edDate.setHours(4, 59, 59, 999);
              }
              edDate = edDate.toISOString();
              if (dateFormat){
                edDate = moment(edDate).format(dateFormat);
              }
            }
            apply(stDate, edDate);
          }}
          btnExtraStyle={{
            borderRadius: '1.5rem',
            backgroundColor: '#004540',
            padding: '6px 30px',
          }}
        />
      </div>
    </div>
  );
};

export default StartAndEndDateFilter;